import React, { useEffect } from "react";
import { Form, Flex, theme } from "antd";
import { HeaderApp } from "../../shared";
import { useCreateProduct } from "../hooks/useCreateProduct";
import type { ProductData } from "../types";
import openNotification from "../../../utils/openNotification";
import { useNavigate } from "react-router-dom";
import ProductForm from "../components/ProductForm";

const NewProduct: React.FC = () => {
  const [form] = Form.useForm();
  const { token } = theme.useToken();
  const { mutate: createProductMutation, isPending: isCreating } = useCreateProduct();
  const navigate = useNavigate();

  const handleFinish = async (values: ProductData) => {
    createProductMutation(values, {
      onSuccess: () => {
        form.resetFields();
        navigate('/catalogo/productos');
        openNotification('success', 'Producto creado exitosamente');
      },
      onError: (error) => {
        openNotification('error', 'Error', error.message);
      }
    });
  };

  useEffect(() => {
    form.setFieldValue("product_iva", 0);
    form.setFieldValue("product_iva_percentage", 16);
  }, [])

  return (
    <Flex
      vertical
      style={{
        background: token.colorBgLayout,
      }}
    >
      <HeaderApp sectionName="Agregar Nuevo Producto" showBack />

      <Flex
        vertical
        gap={28}
        style={{
          maxWidth: 640,
          width: "100%",
          margin: "0 auto",
          padding: "28px 24px 100px",
        }}
      >
        <ProductForm 
            form={form} 
            onFinish={handleFinish} 
            isPending={isCreating} 
            buttonText="Guardar Producto" 
            formId="new-product-form"
        />
      </Flex>
    </Flex>
  );
};

export default NewProduct;
